<template>
  <div></div>
</template>

<script>
export default {
  name: "Inventory"
};
</script>
